import React, { useContext } from 'react';

import { HeaderTitle, Step } from 'app/modules/RestorePassword/types';

import { Modal } from 'app/design-system/components/Modal';
import { tFunction, useTranslation } from 'app/lang';
import { DATA_TYPE } from 'app/modules/RestorePassword/constants';

import { StepContext } from '../../contexts/stepContext';
import { UserContext } from '../../contexts/userContext';

import dictionary from './ModalHeader.dictionary.json';

const getHeaderTitle = (t: tFunction): HeaderTitle => ({
  INITIAL: t(dictionary.initialHeaderTitle),
  CODE: t(dictionary.codeHeaderTitle),
  PASSWORD: t(dictionary.passwordHeaderTitle),
  DONE: t(dictionary.doneHeaderTitle),
});

const ModalHeader = (): JSX.Element => {
  const { t } = useTranslation();
  const { activeStep } = useContext(StepContext);
  const { userData: { type } } = useContext(UserContext);

  const dataType = type && type.toLowerCase() === DATA_TYPE.phoneNumber
    ? t(dictionary.dataTypePhoneNumber)
    : t(dictionary.dataTypeEmail);

  const headerTitle = getHeaderTitle(t);

  const title = activeStep !== Step.CODE
    ? headerTitle[Step[activeStep]]
    : `${headerTitle[Step[activeStep]]} ${dataType}`;

  return (
    <Modal.Header
      data-test="Modal-restorePassword-header">
      {title}
    </Modal.Header>
  );
};

export default ModalHeader;
